// extracted by mini-css-extract-plugin
module.exports = {"cont":"AuthLoginZsms_cont__1eTZ_","box-form":"AuthLoginZsms_box-form__39LO_","info":"AuthLoginZsms_info__eatdb"};